import { render, staticRenderFns } from "./UserProperties.vue?vue&type=template&id=456f86db&scoped=true&"
import script from "./UserProperties.vue?vue&type=script&lang=js&"
export * from "./UserProperties.vue?vue&type=script&lang=js&"
import style0 from "./UserProperties.vue?vue&type=style&index=0&id=456f86db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f86db",
  null
  
)

export default component.exports